<script setup>
import { computed, toRefs } from 'vue';
import { useRoute } from 'vue-router';
import { useDark } from '@vueuse/core';

import logoLight from '@/assets/images/logos/full-png-light.png';
import logoDark from '@/assets/images/logos/full-png-dark.png';
import iconLight from '@/assets/images/logos/180x180-light.png';
import iconDark from '@/assets/images/logos/180x180-dark.png';

import { useProjectStore } from '@/stores/project';

const props = defineProps({
  class: {
    type: String,
    default: '',
  },
});
const { class: classList } = toRefs(props);

const projectStore = useProjectStore();

const route = useRoute();
const projectId = computed(
  () => route.params.projectId || projectStore.currentProjectId
);

const isDark = useDark();
const logo = computed(() => (isDark.value ? logoDark : logoLight));
const icon = computed(() => (isDark.value ? iconDark : iconLight));
</script>

<template>
  <router-link
    v-if="projectId"
    v-slot="{ href, navigate }"
    :to="{ name: 'Dashboard', params: { projectId }, force: true }"
    custom
  >
    <a
      v-ripple
      :href="href"
      @click="navigate"
      class="inline-block flex h-16 w-full cursor-pointer items-center md:relative"
      :class="classList"
    >
      <img
        :src="logo"
        alt="Cognitive Cloud logo"
        class="hidden h-full md:block"
      />
      <img :src="icon" alt="Cognitive Cloud logo" class="h-full md:hidden" />
      <Tag
        severity="primary"
        class="absolute left-12 top-2 scale-75 md:left-[230px] md:top-3 md:dark:left-[220px]"
        value="ALPHA"
      />
    </a>
  </router-link>
</template>
